module.exports = __webpack_public_path__ + "static/media/thumbnail.a23f3710.webp";